import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import styles from "./item-image.module.css";
import { FallbackItemImage } from "@coworker/apprestructured/src/shared/components/FallbackItemImage/FallbackItemImage";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import ImageStrikeThroughIconPath from "@ingka/ssr-icon/paths/image-strikethrough";
import { SVGProps } from "react";
import { getSmallThumbnailImageUrl } from "../../../helpers/image.url.helper";

interface SmallItemImageProps {
  imageUrl: string;
  fallbackImageIcon?: (prefix?: string | undefined) => SVGProps<SVGElement>[];
}

export const SmallItemImage = ({
  imageUrl,
  fallbackImageIcon = ImageStrikeThroughIconPath,
}: SmallItemImageProps) => {
  if (imageUrl && imageUrl !== "") {
    return (
      <FixaImage
        className={styles["small-item-image-container"] ?? ""}
        src={getSmallThumbnailImageUrl(imageUrl)}
      />
    );
  }
  return (
    <FallbackItemImage
      classname={styles["fallback-small-item-image-container"] || ""}
    >
      <FixaSSRIcon paths={fallbackImageIcon} />
    </FallbackItemImage>
  );
};
